<template>
  <div>

    <div class="search-box mt-10">
      <el-form :inline="true" :model="formData" class="user-form-inline" size="mini">
        <el-form-item label="帖子内容">
          <el-input 
          v-model="formData.title"
          clearable :readonly="isSearching"
          placeholder="请输入关键词" 
          style="width:120px"
          @keyup.enter.native="doSearch"
          @clear="doReset"
          @blur="doBlur"></el-input>
        </el-form-item>
        <el-form-item label="同步状态">
          <el-select 
            v-model="formData.syncing" 
            placeholder="请选择" 
            style="width:100px">
            <el-option label="全部" value=""></el-option>
            <el-option label="已同步" value="true"></el-option>
            <el-option label="待同步" value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="doSearch" :loading="isSearching">查询</el-button>
        </el-form-item>
      </el-form>

    </div>
    <el-divider></el-divider>
    <div>
      <el-table
        :data="list"
        v-loading="isSearching"
        style="width: 100%"
        row-key="extPostId"
        border
        size="mini">



        <el-table-column
          width="60"
          label="采集处"
          align="center"
        >
          <template slot-scope="scope">
            <el-image class="logo" :src="logo[scope.row.collectType]"></el-image>
          </template>
        </el-table-column>

        <el-table-column
          prop="title"
          label="帖子内容"
        >
        </el-table-column>

        <el-table-column
          prop="resources"
          label="内容预览"
          width="200"
          align="center"
        >
           <template slot-scope="props">
             <Resources :list="props.row.resources" height="120px"/>
           </template>
        </el-table-column>
        <el-table-column
          prop="syncing"
          label="状态"
          width="200"
          align="center"
        >
           <template slot-scope="props">

             <el-tag type="info" effect="dark" v-if="!props.row.syncing">未同步</el-tag>
             <el-tag type="success" size="mini" effect="dark" v-if="props.row.syncing">{{props.row.syncingAt}} 已同步</el-tag>
           </template>
        </el-table-column>
        <el-table-column 
          label="操作" 
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <div v-if="!scope.row.syncing">
              <el-button
                size="mini"
                type="primary"
                @click="doEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button
                size="mini"
                type="danger"
                @click="doDelete(scope.$index, scope.row)">删除</el-button>
              <br/>
              <el-button
                class="mt-10"
                size="mini"
                type="success"
                @click="doSyncById(scope.row)" v-if="!scope.row.syncing" :loading="isSyncIdLoading==scope.row.postingId">立即同步</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-divider></el-divider>
      <div class="ta-r">
        <el-pagination
          background
          hide-on-single-page
          layout="prev, pager, next"
          @current-change="doChangePage"
          :page-size="pagination.size"
          :current-page="pagination.page"
          :total="total">
        </el-pagination>
      </div>

    </div>
    <PostEdit :data="currentData" :show.sync="showFormEdit" />

  </div>
</template>

<script>
import Resources from '@/components/Resources';
import PostEdit from '@/components/PostEdit';
export default {
  name: 'User-List',
  components: {
    Resources,PostEdit
  },
  data(){
    
    return {
      formData:{
        title:"",
        syncing:"true"
      },
      pagination:{
        size:10,
        page:1,
      },
      total:0,
      list:[],
      tagList:[],
      isSearching:false,
      isTagLoading:false,
      modelType:'users',
      showFormEdit:false,
      isSyncIdLoading:0,
      currentData:{},
      logo:{
        XHS:require('@/assets/common/logo_xhs.png'),
        INS:require('@/assets/common/logo_ins.png'),
      }
    };
  },
  watch: {
    showFormEdit(newData){
      if(!newData){
        this.doSearch(false);
      }
    }
  },
  mounted () {
    this.doSearch();
  },
  methods: {
    doSyncById(item){
      
      this.isSyncIdLoading = item.postingId;
      var postingId = item.postingId;
      this.request.post(`/api/v1/postings/syncing/${postingId}`,{postingId}).then(res=>{
        this.isSyncIdLoading = 0;
        if(!res){return ;}
        this.$message.success("同步帖子成功!");
        this.doSearch(false);
      })
    },
    doEdit(index,row){
      console.log(row);
      this.currentData = this.$root.copy(row);
      this.showFormEdit = true;
    },
    doDelete(index,row){
      this.$confirm('此操作将永久删除该同步帖子, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.delete(`/api/v1/postings/${row.postingId}`).then(res=>{

          if(!res){return ;}
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.doSearch(false);
        })
        
      }).catch(() => {
                
      });
      
    },
    doSearchTag(query){
      var tagName = query.replace(/(^\s*)|(\s*$)/g, "");
      this.isTagLoading = true;

      this.request.get(`/api/v1/tags?page=1&size=5&tagName=${tagName}`).then(res=>{
        this.isTagLoading = false;
        this.tagList = [];
        if(!res || !res.results){return ;}
        this.tagList = res.results;
      });
    },

    getPosts(){
      console.log(arguments)
    },

    getList(url){
      this.isSearching = true;
      this.request.get(url).then(res=>{
        this.isSearching = false;
        this.list = [];
        this.total = 0;
        this.pagination.page = 1;
        if(!res){return ;}
        this.list = res.results || [];
        // this.list.map(d=>{
        //   d.resources.unshift({type:"IMAGE",url:d.thumbnailUrl});
        // })
        this.total = res.total;
        // this.total = 646;
        this.pagination.page = res.page;

      });
    },
    doSearch(resetPage = true){
      // if(!this.formData.collectUserName){
      //   this.$message.warning("搜索内容不能为空");
      //   return ;
      // }
      

      var formData = {...this.pagination,...this.formData};
      if(resetPage){formData.page = 1;}
      var params = this.$root.object2urlparams(formData);


      this.getList(`/api/v1/postings?${params}`);
      
    },
    doChangeCollectType(){
      if(!this.formData.collectUserName){return ;}
      this.doSearch(false);
    },
    doChangePage(currentPage){
      var formData = {...this.pagination,...this.formData};
      formData.page = currentPage;
      var params = this.$root.object2urlparams(formData);
      this.getList(`/api/v1/postings?${params}`);
    },
    doBlur(){
      // if(!this.formData.collectUserName){this.doReset();}
    },
    doReset(){
      this.list = [];
      this.total = 0;
      this.pagination.page = 1;
      this.doSearch();
      // this.formData.collectType = 'INS';
    },
    doResetTagName(){
      if(this.$route.params.tagName){
        this.$router.push('/Home/Collect/User/List/');
      }
      this.doReset();
    },
  }
}
</script>
<style lang="less" scoped>
.logo{
  width:20px;
  vertical-align: middle;
}
</style>
<style lang="less">
.user-form-inline{
  .search-box{
    .el-select .el-input{
      width:160px;
    }
  }
}
</style>